import {Navigate, Route, Routes} from 'react-router-dom';
import {SnippetConfigurationPage} from "../pages/snippet-configuration-page/snippet-configuration-page";

export const SnippetRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SnippetConfigurationPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
